import * as React from "react";
import { Card, Price } from "@grandvisionhq/common";
/* empty css                        */
const AppointmentProduct = ({ product }) => {
  const { image, name, price } = product ?? {};
  return /* @__PURE__ */ React.createElement(Card, { key: name, layout: "horizontal" }, /* @__PURE__ */ React.createElement(Card.Image, { src: image?.url || "", alt: name ?? "", className: "appointment-product__image" }), /* @__PURE__ */ React.createElement(Card.Content, { center: true }, /* @__PURE__ */ React.createElement(Card.Heading, { variant: "subheading1", component: "h3" }, name), price?.amount ? /* @__PURE__ */ React.createElement(Card.Text, null, /* @__PURE__ */ React.createElement(Price, { value: price.amount, currency: price.currencyCode, centAmount: false })) : null));
};
export {
  AppointmentProduct
};
//# sourceMappingURL=AppointmentProduct.js.map
